var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"right":"","color":"primary"},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [(_vm.isDuplicated)?_c('v-icon',_vm._g(_vm._b({attrs:{"color":"red","small":""}},'v-icon',attrs,false),on),[_vm._v(" mdi-alert-circle ")]):_vm._e()]}}])},[_c('span',[_vm._v("Coincidencia")])])
}
var staticRenderFns = []

export { render, staticRenderFns }